<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :product-options="productOptions"
      search-label="search"
      vertical-scroll
      :filter-names="filterNames"
      @filterOption="onFiltersChange"
    >
      <template v-slot:services="{ item }">
        <div class="text-capitalize">
          {{ item.services }}
        </div>
      </template>
      <template v-slot:name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
      <template v-slot:type="{ item }">
        <div class="text-capitalize">
          {{ item.type }}
        </div>
      </template>

      <template v-slot:terminal_name="{ item }">
        <div class="text-capitalize">
          {{ item.terminal_name }}
        </div>
      </template>
      <template v-slot:fuel_type="{ item }">
        <div class="text-capitalize">
          {{ item.fuel_type }}
        </div>
      </template>
      <template v-slot:operational_status="{ item }">
        <div> {{ (item.operational_status) ? 'Active' : 'Inactive' }}</div>
      </template>
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template #addFilters>
        <v-card>
          <v-select
            v-model="terminal_id"
            filled
            dense
            clearable
            :items="terminalList"
            item-value="id"
            item-text="name"
            :label="$t('terminal')"
            @change="fetchData"
          />
        </v-card>
        <v-card>
          <v-select
            v-model="operational_status"
            filled
            dense
            clearable
            :items="statusOptions"
            item-value="id"
            item-text="name"
            :label="$t('status')"
            @change="fetchData"
          />
        </v-card>
      </template>

      <!-- Action Modals -->
      <template #actionModals>
        <div class="d-flex">
          <create-modal
            v-if="isCreate"
            :filter-options="options"
          />
          <edit-modal
            v-if="(isView || isEdit) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateModal: () => import("./dialogs/CreateFuel.vue"),
    EditModal: () => import("./dialogs/EditFuel.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      permissions: {
        view: "fuel-tanks.view",
        create: "fuel-tanks.create",
        edit: "fuel-tanks.edit",
        delete: "fuel-tanks.delete",
      },
      locationModal: false,
      productOptions: [
        { id: "oem", value: "OEM" },
        { id: "fleet", value: "Fleet" },
        { id: "dispenser", value: "Dispenser" },

      ],
      operational_status: null,
      isMounted: false,
      filters: {},
      subFilters: {},
      terminal_id: null,
      statusOptions: [
        {
          id: true,
          name: "active",
        },
        {
          id: false,
          name: "inactive",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "fuelTanks/getLoading",
      meta: "fuelTanks/getMeta",
      list: "fuelTanks/getList",
      terminalList: "terminal/getTerminalDropDown"
    }),
    filterNames() {
      return [];
    },
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("name"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        ...(this.authUser.user_nature == "fleet"
          ? [
            {
              text: this.$t("manufacturer"),
              align: "left",
              sortable: false,
              value: "tenant_name",
            },
          ]
          : []),
        {
          text: this.$t("terminal"),
          align: "left",
          sortable: false,
          value: "terminal_name",
        },
        {
          text: this.$t("type"),
          align: "left",
          sortable: false,
          value: "type",
        },
        {
          text: this.$t("capacity")+' (L)',
          align: "left",
          sortable: false,
          value: "capacity",
        },
        {
          text: this.$t("fuel_type"),
          align: "left",
          sortable: false,
          value: "fuel_type",
        },
        // {
        //   text: this.$t("min"),
        //   align: "left",
        //   sortable: false,
        //   value: "min_temperature",
        // },
        // {
        //   text: this.$t("max"),
        //   align: "left",
        //   sortable: false,
        //   value: "max_temperature",
        // },
        {
          text: this.$t("imei"),
          align: "left",
          sortable: false,
          value: "iot_device_imei",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "operational_status",
        },
        ...(this.isView || this.isEdit || this.isDelete
          ? [
            {
              text: this.$t("actions"),
              align: "left",
              sortable: false,
              value: "actions",
            },
          ]
          : []),
      ];
      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

  },
  watch: {
    // "options.fleetId": {
    //   handler: function (val) {
    //     if (this.isMounted) {
    //       this.terminal_id = "";
    //     }
    //     this.isMounted = true;
    //     if (val) {
    //       const params = { tenant_id: val };
    //       this.$store.dispatch("terminal/dropDownList", params);
    //     } else {
    //       this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
    //     }
    //   },
    // },
    // "options.tenant_id": {
    //   handler: function (val) {
    //     if (this.isMounted) {
    //       this.terminal_id = "";
    //     }
    //     this.isMounted = true;
    //     if (val) {
    //       const params = { tenant_id: val };
    //       this.$store.dispatch("terminal/dropDownList", params);
    //     } else {
    //       this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
    //     }
    //   },
    // },
    options(val) {
      if (this.authUser.isAdmin) {
        if (!val.tenant_id) {
          this.options.tenant_id = val.fleetId
        }
        if (this.isMounted) {
          this.terminal_id = "";
        }
        this.isMounted = true;
        if (this.options.tenant_id) {
          const params = { tenant_id: this.options.tenant_id };
          this.$store.dispatch("terminal/dropDownList", params);
        } else {
          this.$store.commit("terminal/SET_LIST_DROPDOWN", []);
        }
      }
      this.fetchData();
    },
  },
  async mounted() {
    this.$store.dispatch('fuelTanks/setLoadingValue', true)
    if (!this.authUser.isAdmin) {
      const params = { tenant_id: this.authUser.tenant_id };
      await this.$store.dispatch("terminal/dropDownList", params);
    }
    if (this.$route?.query?.terminal_id) {
      this.terminal_id = this.$route.query.terminal_id;
    }
    if (this.$route?.query?.operational_status) {
      this.operational_status = (this.$route.query.operational_status);
    }
  },

  beforeDestroy() {
    const paramsset = { ...this.options };
    paramsset.terminal_id = this.terminal_id;
    paramsset.operational_status = this.operational_status;
    const params = {
      name: "fuel_tank",
      filters: paramsset,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {

    async fetchData() {
      this.options.operational_status = this.operational_status
      // (this.options.status != null) ? (this.options.status == 'active' ? true : false) : ''
      this.options.terminal_id = this.terminal_id
      this.options.page = 1;
      await this.$store
        .dispatch("fuelTanks/list", this.options)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("fuelTanks/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
    //
    //
    toggelLocationsModal() {
      return (this.locationModal = !this.locationModal);
    },
  },
};
</script>
<style lang="sass" scoped>
.map-button
  height: 41px !important
  margin-right: 5px

.btn-disabled
  pointer-events: none !important
  background-color: #8f8f8f !important

:deep .v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line):not(.v-text-field--outlined).v-input--dense .v-select__slot > input
  font-size: 0.875rem !important
</style>